var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top_info_container gas"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("median gas price")]), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.gasPrice) + " nDCM")]), _c('p', {
    staticClass: "description usd-before"
  }, [_vm._v(_vm._s(_vm.inUSD))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }